// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","footerLinks":"A8hXA","linkItem":"_3Y5yH","link":"_3SEjD"};